import { env } from '@/env'

// export const SIGN_IN_LINK = `https://sso.contester.life/oidc/auth?client_id=awsstcw8uoq7za3uzqi8b&response_type=code&redirect_uri=${encodeURIComponent(
//   `${env.NEXT_PUBLIC_BACKEND_URL.replace(/\/$/, '')}/auth/callback`
// )}&scope=email%20custom_data%20identities%20profile%20openid`

export function getSignInLink(navigateTo: string): string {
  return `https://sso.contester.life/oidc/auth?client_id=awsstcw8uoq7za3uzqi8b&response_type=code&state=${encodeURIComponent(navigateTo)}&redirect_uri=${encodeURIComponent(
    `${env.NEXT_PUBLIC_BACKEND_URL.replace(/\/$/, '')}/auth/callback`
  )}&scope=email%20custom_data%20identities%20profile%20openid`
}
